import * as yup from "yup";

export const validationSchema = yup.object().shape({
    // child_discount: yup
    //     .number()
    //     .typeError('Это поле должно быть числом')
    //     .positive('Напишите положительные числа'),
    // child_price: yup
    //     .number()
    //     // .required('Это обязательное поле')
    //     .typeError('Это поле должно быть числом')
    //     .positive('Напишите положительные числа')
    //     .min(0, "Минимум может быть установлен до 0"),
    // discount: yup
    //     .number()
    //     .typeError('Это поле должно быть числом')
    //     .positive('Напишите положительные числа'),
    // price: yup
    //     .number()
    //     // .required('Это обязательное поле')
    //     .typeError('Это поле должно быть числом')
    //     .positive('Напишите положительные числа')
    //     .min(0, "Минимум может быть установлен до 0"),

})